import { render } from "./CvDownloadButton.vue?vue&type=template&id=7ca46a4e"
import script from "./CvDownloadButton.vue?vue&type=script&lang=js"
export * from "./CvDownloadButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__